module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Mirror-8e27a990f5911131793854cb9a6abc1e.svg";